import { Gun, KeyVar } from "../types"
import Tank from '../assets/tank.svg'
import Fire from '../assets/fire.svg'
import Freeze from '../assets/freeze.svg'

export const zoneColors: {
    [key in keyof typeof Gun]: string
} = {
    gun: 'gun',
    freeze: 'freeze',
    fire: 'fire',
}

export const gunImages: {
    [key in keyof typeof Gun]: any
} = {
    gun: Tank,
    freeze: Freeze,
    fire: Fire,
}

export const rotates: {
    [key in keyof typeof KeyVar]: number
} = {
    w: 0,
    a: 270,
    s: 180,
    d: 90
}

export const calcDangerZone = (seconds: number): number => {
    let zone = 0
    if (seconds > 325) zone = 1
    if (seconds > 326) zone = 2
    if (seconds > 327) zone = 3

    if (seconds > 415) zone = 4
    if (seconds > 416) zone = 5
    if (seconds > 417) zone = 6
    if (seconds > 418) zone = 7
    if (seconds > 419) zone = 8
    if (seconds > 420) zone = 9

    if (seconds > 500) zone = 10
    if (seconds > 501) zone = 11
    if (seconds > 502) zone = 12
    if (seconds > 503) zone = 13
    if (seconds > 504) zone = 14
    if (seconds > 505) zone = 15
    if (seconds > 506) zone = 16
    if (seconds > 507) zone = 17
    if (seconds > 508) zone = 18
    if (seconds > 509) zone = 19
    if (seconds > 510) zone = 20
    return zone
}